import React, { useEffect, useState } from 'react';
import { Box, Stepper, Step, StepLabel, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import Login from './common/Login';
import i18n from 'i18n';
import FamiliplusLogo from 'assets/FamiliplusLogo';

const steps = [
  {
    label: 'Steps.1',
  },
  {
    label: 'Steps.2',
  },
  {
    label: 'Steps.3',
  },
  {
    label: 'Steps.4',
  },
];

const DesktopNavbar = (props: { index: number | 1 }) => {
  const [isFamiliplusStepActive, setisFamiliplusStepActive] = useState(false);
  const { t } = useTranslation('component');

  useEffect(() => {
    //Etape 0 = Identification, Etape 1 = Familiplus
    setisFamiliplusStepActive(props.index == 1);
  }, [props.index]);

  const familiplusLogo = (
    <FamiliplusLogo
      color={isFamiliplusStepActive ? '#FFF' : '#FFFFFF80'}
      style={{
        width: '5.3em',
        position: 'relative',
        top: i18n.resolvedLanguage == 'en' ? '4px' : '5px',
        margin: i18n.resolvedLanguage == 'en' ? '0' : '0 0 0 2px',
      }}
    />
  );

  return (
    <>
      <Stepper activeStep={Math.floor(props.index)} orientation="vertical">
        {steps.map((step, index) => (
          <Step completed={Math.round(props.index) > index} key={step.label}>
            <StepLabel>
              {step.label == 'Steps.2' ? (
                <Trans
                  style={{ whiteSpace: 'pre-wrap' }}
                  t={t}
                  components={{
                    logo: familiplusLogo,
                  }}>
                  {t('Steps.2') + ' '}
                </Trans>
              ) : (
                t(step.label) + ' '
              )}
              {step.label != 'Steps.1' ? t('Form.Optional') : ''}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </>
  );
};

const MobileNavbar = (props: { index: number | 1; fullNavbar: boolean }) => {
  const displayFullNavbar = props.fullNavbar ? true : false;

  return (
    <>
      {!displayFullNavbar && (
        <>
          <Stepper activeStep={Math.floor(props.index)} alternativeLabel sx={{ paddingTop: '8px' }}>
            {steps.map((step, index) => (
              <Step completed={Math.round(props.index) > index} key={step.label}>
                <StepLabel />
              </Step>
            ))}
          </Stepper>
        </>
      )}
      {displayFullNavbar && (
        <>
          <DesktopNavbar index={props.index}></DesktopNavbar>

          {props.index == 0 && (
            <Box pt={25}>
              <Login />
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default function Navbar(props: { index: number | 1; fullNavbar: boolean }): JSX.Element {
  const { t } = useTranslation('component');
  const showTitle = props.index > 1 ? 'none' : 'block';
  const showSubtile = props.index == 1 || props.fullNavbar ? 'block' : 'none';
  return (
    <Box
      sx={{
        paddingLeft: { xs: props.fullNavbar ? '9%' : '0', sm: '10%', md: '48px' },
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Box
        sx={{
          display: { xs: showTitle, md: 'block' },
          paddingLeft: { xs: props.fullNavbar ? '0' : '9%', sm: props.fullNavbar ? '0' : '10%', md: '0' },
        }}>
        <Typography component="h1" variant="h2" sx={{ color: '#fff', margin: '1em 0 0' }}>
          {t('NavBar.NavTitle')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: { xs: showSubtile, md: 'block' },
          paddingLeft: { xs: props.fullNavbar ? '0' : '9%', sm: props.fullNavbar ? '0' : '10%', md: '0' },
          height: { md: '80px' },
        }}>
        <p>{t('NavBar.NavDescription')}</p>
      </Box>
      <Box sx={{ display: { xs: 'block', md: 'none' }, p: '16px 0' }}>
        <MobileNavbar index={props.index - 1} fullNavbar={props.fullNavbar}></MobileNavbar>
      </Box>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <DesktopNavbar index={props.index - 1}></DesktopNavbar>
      </Box>
    </Box>
  );
}
//paddingLeft: { xs: props.fullNavbar ? '0' : '9%', sm: '10%', md: '0' }
//Props.index - 1 pour que l'index sois egal a l'etape presente sinon 0 = etape 1
